const CREATE_RELEASE_VERSION = 'CREATE_RELEASE_VERSION';

const ACTION_TYPES = {
  CREATE_RELEASE_VERSION,
};

export default ACTION_TYPES;
